module.exports = __webpack_public_path__ + "media/images/webpage/shared/imgproxy/blank-medium-709784bac79dffa8bb40549db69436ce.svg";